import { render, staticRenderFns } from "./LaunchVirtualVisit.vue?vue&type=template&id=2fe46afc"
import script from "./LaunchVirtualVisit.vue?vue&type=script&lang=js"
export * from "./LaunchVirtualVisit.vue?vue&type=script&lang=js"
import style0 from "./LaunchVirtualVisit.vue?vue&type=style&index=0&id=2fe46afc&prod&style=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports